export default "__VITE_ASSET__79632d12__"